/**
 * Ilovadagi barcha manzillar. Marshrutlar ham, sidebar ham, `<NavLink>` ham
 * shu yerdan o'qiydi: manzil bir joyda o'zgarsa, hamma joyda o'zgaradi.
 *
 * Panelda rol prefiksi YO'Q (`/admin/*`, `/moderator/*` emas). Admin va
 * moderator bir xil ekranlarni ko'radi, farq faqat ruxsatda — va u
 * backendda hal qilinadi. Ikkita parallel manzil daraxti esa har bir
 * havolani ikki marta yozishga majbur qilardi.
 */
export const PAGE_PATHS = {
  ROOT: "/",
  LOGIN: "/login",

  DASHBOARD: "/dashboard",

  // Moderatsiya
  COURSE_MODERATION: "/moderation/courses",
  COURSE_MODERATION_REVIEW: "/moderation/courses/:id",
  POST_MODERATION: "/moderation/posts",
  REVIEW_MODERATION: "/moderation/reviews",
  /** AI kontent filtri belgilagan xabar, izoh va postlar (ADR 0012, #8). */
  AI_FLAGS: "/moderation/ai-flags",
  TEACHER_REQUESTS: "/moderation/teacher-requests",
  /** Talabani kursdan chetlashtirishlar — platforma bo'yicha nazorat. */
  REMOVALS: "/moderation/removals",
  /** Moderatorning o'z qarorlari: nima, qachon va qancha kutib hal qilingan. */
  MY_DECISIONS: "/moderation/my-decisions",

  // Kontent
  COURSES: "/courses",
  /**
   * Yaratish va tahrirlash bitta sehrgar: `/courses/new` da birinchi qadam
   * kursni yaratadi va shu zahoti `/courses/:id` ga o'tadi, ya'ni qolgan
   * qadamlar (dastur, media, narx) allaqachon saqlangan qoralama ustida
   * ishlaydi.
   */
  COURSE_NEW: "/courses/new",
  COURSE_EDIT: "/courses/:id",
  /** Bitta darsning turiga mos kontent muharriri. */
  LESSON_CONTENT: "/courses/:courseId/lessons/:lessonId",
  LIVE_COURSES: "/live-courses",
  LIVE_COURSE_NEW: "/live-courses/new",
  LIVE_COURSE_EDIT: "/live-courses/:id",
  /** Jonli guruh nazorati: qabul, talabalar, darslar, yakunlash. */
  LIVE_COURSE_MANAGE: "/live-courses/:id/manage",
  NEWS: "/news",
  NEWS_NEW: "/news/new",
  NEWS_EDIT: "/news/:id",

  // Odamlar
  USERS: "/users",
  CONTACT_MESSAGES: "/contact-messages",

  // Pul
  PAYMENTS: "/payments",
  /** Kartaga to'lov cheklari — tasdiq navbati va tarix (faqat admin). */
  CARD_REVIEW: "/payments/card-review",
  /** O'qituvchilarning pul yechish arizalari (faqat admin). */
  WITHDRAWALS: "/payments/withdrawals",
  /** O'quvchilarning pulni qaytarish so'rovlari (faqat admin). */
  REFUND_REQUESTS: "/payments/refunds",
  ANALYTICS: "/analytics",

  // Hisobotlar (faqat admin)
  REPORT_TEACHERS: "/reports/teachers",
  REPORT_TEACHER: "/reports/teachers/:id",
  REPORT_STUDENTS: "/reports/students",
  REPORT_STUDENT: "/reports/students/:id",
  REPORT_COURSES: "/reports/courses",
  REPORT_AT_RISK: "/reports/at-risk",
  REPORT_MODERATORS: "/reports/moderators",
  REPORT_MODERATOR: "/reports/moderators/:id",
  REPORT_ACTIVITY: "/reports/activity",
  REPORT_COHORTS: "/reports/cohorts",
  REPORT_PAYOUTS: "/reports/payouts",
  REPORT_GRADE_CHANGES: "/reports/grade-changes",

  // Tizim
  CATEGORIES: "/categories",
  COURSE_LEVELS: "/course-levels",
  ANNOUNCEMENTS: "/announcements",
  /** E'lon yozish — ro'yxatdan alohida sahifa: forma jadvalni ekrandan itarmasin. */
  ANNOUNCEMENT_NEW: "/announcements/new",
  NOTIFICATIONS: "/notifications",
  HEALTH: "/health",
  /** Platforma ulushi va haftalik hisobot. */
  PLATFORM_SETTINGS: "/settings/platform",
  /** AI: modellar, sozlamalar va sarf (ADR 0012). */
  AI: "/ai",

  // Hisob
  SECURITY: "/security",
  PROFILE: "/profile",
} as const;

/** `:id` o'rniga haqiqiy identifikatorni qo'yadi. */
export const buildPath = (pattern: string, params: Record<string, string | number>): string =>
  Object.entries(params).reduce(
    (path, [key, value]) => path.replace(`:${key}`, String(value)),
    pattern,
  );
